import React, { type ChangeEvent, createRef } from "react";
import { ActionType, useProductMediaDispatch } from "./FilesContext";
import { uploadFile } from "@admin/domain/files/api";

type Props = {
    mediaId?: string | number;
};

export default function AddImageButton({ mediaId }: Props) {
    const dispatch = useProductMediaDispatch();
    const imageUpload: React.RefObject<HTMLInputElement> = createRef();

    const onAddImage = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
        if (!event.target.files) {
            return;
        }

        const mediaFile = await uploadFile(event.target.files.item(0) as File);

        dispatch({
            type: mediaId ? ActionType.AddMobileAppFile : ActionType.AddFile,
            productMediaFile: mediaFile,
            mediaId,
        });
    };

    return (
        <div className="me-5">
            <input className="d-none" type="file" accept="image/*" ref={imageUpload} onChange={onAddImage} />
            <button type="button" className="btn btn-primary" onClick={() => imageUpload.current?.click()}>
                Добавить изображение {mediaId ? `для МП` : ``}
            </button>
        </div>
    );
}
